import React, { Component } from 'react';
import "./SelectSearch.css";
import Select, { components, createFilter } from 'react-select';

const Control = (props) => {
	const { withIcon } = props.selectProps;

	return (
		<components.Control {...props}>
			{withIcon && <i className="fas fa-search" aria-hidden="true"></i>}
			{props.children}
		</components.Control>
	);
};

const DropdownIndicator = (props) => {
	const { menuIsOpen } = props.selectProps;
	const iconClass = menuIsOpen ? "fa-angle-up" : "fa-angle-down";
	
	return (
		<components.DropdownIndicator {...props}>
			<button className='br-button'>
				<i className={`fas ${iconClass}`} aria-hidden="true" />
			</button>	
		</components.DropdownIndicator>
	);
};

const LoadingIndicator = (props) => {
	return (
		<button className="loading-button is-secondary is-circle is-loading" type="button"/>
	);
};

const MultiValue = () => null	

const CustomMultiValueRemove = () => null;

const CheckboxOption = (props) => {
	const { isSelected, label, value, selectProps } = props;
	const { options, value: selectedValues } = selectProps;

	const isSelectAll = value === "*";
	const allSelected = selectedValues?.length === options.length - 1;
	const checked = isSelectAll ? allSelected : isSelected;

	return (
		<components.Option {...props}>
		<input
			type="checkbox"
			checked={checked}
			onChange={() => null}
			style={{
				marginRight: 8,
				accentColor: "white",
			}}
		/>
		<label>{label}</label>
		</components.Option>
	)
};

const ValueContainer = ({ children, ...props }) => {
	const { selectProps } = props;
	const { value, maxMultiSelectValues, optionName } = selectProps;

	let tmpChildren = [...children];

	if (children[0] != null) {
		const length = children[0].length

		if( length > maxMultiSelectValues) {
			tmpChildren[0] = `${value.slice(0, maxMultiSelectValues).map((v) => v[optionName]).join(", ")} + (${length - maxMultiSelectValues})`
		} else if(length > 0) {
			tmpChildren[0] = `${value.map((v) => v[optionName]).join(", ")}`
		}
	}

	return (
		<components.ValueContainer {...props}>{tmpChildren}</components.ValueContainer>
	);
};

const searchConfig = {
	ignoreCase: true,
	ignoreAccents: true,
	trim: true,
	matchFrom: 'any',
	stringify: option => `${option.label}`,
};

const customStyles = {
	indicatorSeparator: () => ({
		display: 'none',
	}),
	control: (provided, state) => ({
		...provided,
		backgroundColor: state.isDisabled ? '#ededed' : 'white',
		border: state.isFocused ? '1px solid #2670e8' : '1px solid #888' ,
		outline: state.isFocused ? 'none !important' : 'none !important',
		// width: '100%',
		borderRadius: '6px',
		color: '#555',
		fontSize: '16px',
		fontWeight: '400',
		paddingLeft: '14px',
	}),
	input: (provided) => ({
		...provided,
		// minWidth: '50px',
		 width: 1,
		 flex: '1 1 auto',
	}),
	menu: (provided) => ({
		...provided,
		borderRadius: 0,
		border: 'none',
		boxShadow: '0 3px 6px rgba(0,0,0,0.16)',
		margin: 1,
	}),
	menuList: (provided) => ({
		...provided,
		padding: 0,
		overflowY: 'auto',
		'::-webkit-scrollbar': {
			width: '10px',
		},
		'::-webkit-scrollbar-track': {
			background: '#e6e6e6',
			borderRadius: '0px',
		},
		'::-webkit-scrollbar-thumb': {
			background: '#adadad',
			borderRadius: '0px',
		},
		'::-webkit-scrollbar-thumb:hover': {
			background: '#333',
		},
	}),
	option: (provided, state) => {
		const { selectProps, data, isSelected, isFocused} = state;
		const { value, options, optionValue } = selectProps;

		const isSelectAllOption = data[optionValue] === "*";
		const totalOptions = options.length - 1;
		const isAllOptionsSelected = value?.length === totalOptions;

		const isSelectedOrAllSelected = isSelected || (isSelectAllOption && isAllOptionsSelected) 

		return {
			...provided,
			color: isSelectedOrAllSelected ? 'white' : '#333',
			padding: '16px',
			borderBottom: 'solid 1px #ccc',
			cursor: 'pointer',
			fontSize: '14px',
			fontWeight:	isSelectAllOption ? 'bold' : '500',
			margin: '0',
			backgroundColor: 	 
				isFocused
					? isSelectedOrAllSelected
						? 'rgba(32, 112, 232, 0.5)'
						: '#f0f0f0' 
					: isSelectedOrAllSelected
						? '#2070e8'
						: 'white'		
		}
	
	},
};

export default class SelectSearch extends Component {
	
	handleOnChangeInput = (inputValue, optionName, optionValue) => {
		const {
			isMulti,
			includeAllOption,
			allOptionName = "Todos",
			options
		} = this.props;

		if (isMulti) {
			return inputValue;
		}

		const isEmpty = 
			inputValue === "" ||
			inputValue === null ||
			inputValue === undefined;

		if (isEmpty) {
			return includeAllOption 
				? { [optionName]: allOptionName, [optionValue]: "" } 
				: "";
		}

		return options.find((option) => option[optionValue].toString() === inputValue.toString());
  	}

	handleOnChangeSelect = (item, optionValue) => {
		const { name, onChange, isMulti, options } = this.props;

		const createEvent = (value) => ({
			target: { name, value }
		});

		if (!isMulti) {
			onChange(createEvent(item[optionValue]));
			return;
		}
		
		const isSelectAllOptionChecked = item.find((i) => i[optionValue] === "*")
		const isAllOptionsChecked = item.length - 1 === options.length
		
		let value;

		if (isSelectAllOptionChecked) {
			value = isAllOptionsChecked ? [] : options;
		} else {
			value = item;
		}

		onChange(createEvent(value));		
	};
      
	render() {        
		const { 
			id, 
			name, 
			value, 
			placeholder = "Selecione", 
			options, 
			allOptionName = "Todos",
			noOptionsMessage = "Não encontramos o que você está procurando!",
			isMulti, 
			withIcon,
			optionName = "label",
			optionValue = "value",
			includeAllOption = isMulti ? true: false,
			defaultValue = includeAllOption ? { [optionName]: allOptionName, [optionValue]: "" } : null,
			isLoading, 
			isSearchable, 
			maxMultiSelectValues, 
			disabled, 
			minMenuHeight, 
		} = this.props;

		const baseOptions = includeAllOption 
			? [{ [optionName]: allOptionName, [optionValue]: "" }, ...options]
			: options

		const multiSelectAllOption = isMulti && (value.length === baseOptions.length) 
			? { [optionValue]: "*", [optionName]: "Desselecionar todos" } 
			: { [optionValue]: "*", [optionName]: "Selecionar todos" };

		const selectOptions = (isMulti && options.length > 0)
			? includeAllOption ? [multiSelectAllOption, ...options] : [...options]	
			: baseOptions;

		const baseComponents = { DropdownIndicator, LoadingIndicator, Control };

		const customComponents = isMulti 
			? { ...baseComponents, ValueContainer, MultiValue, MultiValueRemove: CustomMultiValueRemove, Option: CheckboxOption } 
			: baseComponents;

		return (
			<div style={{ width: "100%", maxWidth: "100%" }}>
				<Select
					classNamePrefix={"react-select"}
					id={id}
					defaultValue={defaultValue}
					styles={customStyles}
					filterOption={createFilter(searchConfig)}
					withIcon={withIcon}
					isMulti={isMulti}
					isDisabled={disabled}
					isLoading={isLoading}
					isClearable={false}
					isRtl={false}
					isSearchable={isSearchable}
					placeholder={placeholder}
					name={name}
					options={selectOptions}
					getOptionLabel={(option) => option[optionName]}
      				getOptionValue={(option) => option[optionValue]}
					components={customComponents} 
					value={this.handleOnChangeInput(value, optionName, optionValue)}
					onChange={item => this.handleOnChangeSelect(item, optionValue)}
					noOptionsMessage={() => noOptionsMessage}
					closeMenuOnSelect={!isMulti}
					hideSelectedOptions={false}
					maxMultiSelectValues={maxMultiSelectValues}
					optionName={optionName}
					optionValue={optionValue}
    				menuPlacement="auto" 
  					minMenuHeight={minMenuHeight}
				/>
			</div>
		);  
	}
}
